import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "text-muted" }

import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import CurrencyInputCustom from "@/components/forms-elements/CurrencyInputCustom.vue";
import QuantityInputCustom from "@/components/forms-elements/QuantityInputCustom.vue";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import type { HopDongHdvtLineDraft } from "@/types/hop-dong";


export default /*#__PURE__*/_defineComponent({
  __name: 'HopDongHdvtTable',
  props: {
    lines: {},
    readonly: { type: Boolean, default: false },
    showDacTinh: { type: Boolean, default: true }
  },
  emits: ["remove-line", "patch-line"],
  setup(__props: any) {





const { ButtonTypeColors, ButtonsType } = useButtonCustom();

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: _ctx.lines,
    border: true,
    "empty-text": "Chưa có vật tư trong hợp đồng",
    "max-height": "560",
    size: "medium",
    style: {"width":"100%"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_table_column, {
        label: "STT",
        width: "70",
        align: "center"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Mã / Tên vật tư",
        "min-width": "220"
      }, {
        default: _withCtx((scope) => [
          (scope.row.ma_vat_tu)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(scope.row.ma_vat_tu), 1))
            : _createCommentVNode("", true),
          (scope.row.ma_vat_tu && scope.row.ten_vat_tu)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - "))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(scope.row.ten_vat_tu || `ID ${scope.row.id_vat_tu}`), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "ĐVT",
        width: "90",
        align: "center"
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(scope.row.don_vi_tinh || "-"), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Số lượng",
        width: "140",
        align: "right"
      }, {
        default: _withCtx((scope) => [
          _createVNode(QuantityInputCustom, {
            "model-value": scope.row.so_luong,
            "class-str": "w-100",
            min: 0.01,
            "is-disabled": _ctx.readonly,
            "onUpdate:modelValue": 
            (val) =>
              _ctx.$emit('patch-line', scope.row._key, {
                so_luong: Number(val) || 0,
              })
          
          }, null, 8, ["model-value", "is-disabled", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Số tiền / Đơn giá",
        width: "160",
        align: "right"
      }, {
        default: _withCtx((scope) => [
          _createVNode(CurrencyInputCustom, {
            "model-value": scope.row.so_tien,
            min: 0,
            "is-disabled": _ctx.readonly,
            "onUpdate:modelValue": 
            (val) =>
              _ctx.$emit('patch-line', scope.row._key, {
                so_tien: Number(val) || 0,
              })
          
          }, null, 8, ["model-value", "is-disabled", "onUpdate:modelValue"])
        ]),
        _: 1
      }),
      (_ctx.showDacTinh)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            label: "Đặc tính",
            "min-width": "160"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.dac_tinh || "—"), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 1,
            label: "",
            width: "70",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(ButtonCustom, {
                "button-type": _unref(ButtonsType).TRASH,
                "color-type": _unref(ButtonTypeColors).DANGER,
                "tooltip-message": "Xoá dòng",
                onClick: ($event: any) => (_ctx.$emit('remove-line', scope.row._key))
              }, null, 8, ["button-type", "color-type", "onClick"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})